<template>
  <div class="three-column-layout" @mouseover="handleMouseover(menu.id)" @mouseout="handelMouseout()">
    <!-- left -->
    <div class="block-left" :style="{ background: `url('${menu.adImg || getBg(menu.defaultAdImg)}') no-repeat right` }">
      <div class="menu-desc-wrapper">
        <div class="menu-desc">
          <div class="title">{{ menu.alias || menu.title }}</div>
          <p class="desc">{{ menu.desc }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="block-ad-img"><img :src="menu.adImg" /></div> -->
    <!-- left right -->
    <div class="block-right">
      <div v-for="menuSub in menuSubList" :key="menuSub.id" class="menu-sub">
        <div class="sub-title">{{ menuSub.title }}</div>
        <ul class="menu-item">
          <li v-for="item in menuSub.children" :key="item.id" class="menu-link">
            <a :href="item.link" target="_blank">
              {{ item.title }}
              <span v-if="item.desc" class="after">{{ item.desc }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="menu-qr">
        <div class="img-con">
          <img src="https://www.esign.cn/upload/resources/image/2024/04/02/42968.png" width="130px" height="130px" alt="体验中心二维码" />
        </div>
        <div class="menu-qr-title"><span>体验中心</span></div>
        <p class="menu-qr-text">微信扫码免费体验</p>
      </div>
    </div>
    <!-- right -->
  </div>
</template>
<script>
export default {
  props: {
    menu: {
      type: Object,
      default() {},
    },
  },
  computed: {
    menuSubList() {
      return this.menu.children
        .filter(sub => {
          return sub.enable
        })
        .map(item => {
          return {
            ...item,
            children: item.children.filter(item => {
              return item.enable
            }),
          }
        })
    },
  },
  methods: {
    handleMouseover(id) {
      this.$emit('mouseover', id)
    },
    handelMouseout() {
      this.$emit('mouseout')
    },
    getBg(name) {
      return require(`@/assets/images/new-header/${name}`)
    },
  },
}
</script>
<style lang="less" scoped>
@import './common.less';

.menu-sub-wrapper {
  .three-column-layout.menu-sub-content {
    height: 300px;
  }
  .menu-desc-wrapper {
    display: flex;
    width: 75%;
  }
  .menu-desc {
    max-width: 440px;
  }

  .block-left {
    width: 60%;
    padding: 54px 14px;
    display: flex;
    justify-content: flex-end;
  }
  .block-right {
    position: relative;
  }
  .block-ad-img {
    width: 16.9%;
    padding: 54px 20px 0 22px;
    box-sizing: content-box;
    img {
      width: 100%;
    }
  }
}

.menu-qr {
  width: 130px;
  height: 180px;
  position: absolute;
  right: 6vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .menu-qr-title {
    width: 98px;
    height: 22px;
    margin-top: 14px;
    background: #e63740;
    border-radius: 11px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    line-height: 22px;
    text-align: center;
  }
  .menu-qr-text {
    width: 96px;
    height: 17px;
    margin-top: 6px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 17px;
    text-align: justify;
    font-style: normal;
  }
  .img-con {
    width: 130px;
    height: 130px;
    background: #ffffff;
    box-shadow: 4px 4px 16px 0 rgba(209, 219, 233, 0.7);
    border-radius: 10px;
    img {
      border-radius: 10px;
    }
  }
}

@media (min-width: 1300px) {
  .menu-qr {
    right: 16vw;
  }
}
</style>
